import './components/question-toggle';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay]);

const swiper = new Swiper(".slider-portfolio", {
  //slidesPerView: 1,
  //allowTouchMove: false,
  //speed: 8000,
  autoplay: {
    delay: 7000,
    disableOnInteraction: true,    
  },  
  autoHeight: true,  
  pagination: {
    el: ".slider-portfolio-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      // Find the corresponding slide to get the title
      const slides = document.querySelectorAll('.swiper-slide');
      const title = slides[index].getAttribute('data-title');
      const subtitle = slides[index].getAttribute('data-subtitle');
      const image = slides[index].getAttribute('data-image');
      
      // Return a custom button string
      return `<button class="${className}">
                <span class="title">${title}</span>
                <span class="subtitle d-none d-md-block">${subtitle}</span>
                <img loading="lazy" src="${image}" alt="${title}">
              </button>`;
    },
  },  
});

document.querySelectorAll('.social-item-content').forEach(container => {
  const playBtn = container.querySelector('.btn-play');

  playBtn.addEventListener('click', function(e) {
    // Prevent the click from bubbling up if necessary
    e.stopPropagation();

    const videoUrl = container.getAttribute('data-video');

    // Replace the entire contents of the container
    // This removes the button and the image simultaneously
    container.innerHTML = `
      <video controls autoplay playsinline height="888" width="500">
        <source src="${videoUrl}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    `;
  }, { once: true });
});